import { z } from 'zod';
import { stampedBody } from '../common/row-version.js';
// Wire contract for setting an ordered accountability chain at a scope — the
// whole-chain PUT (ADR-026 §C). LEVEL-AGNOSTIC: the same body sets a chain at a
// zone, cluster, team, vehicle-pool, site, or warehouse — the scope is named by
// the URL (`/zones/:zoneId/...`) and the level is resolved server-side from the
// responsibility definition. The service takes the desired ordered set and diffs
// + renumbers `display_order` 1..N — it is NOT separate assign/reorder/remove calls.
//
// `userIds` is the ordered chain (index 0 = lead, the rest backups); an empty
// array clears the chain. Members are validated server-side (active project
// membership); the cap guards against a pathological payload. Each id is a
// `usr_`-prefixed nanoid (varchar(16)).
//
// `grant_backing` (ADR-052 scope-backed accountability): default false. A NEW
// assignee who can't see this place is rejected (ASSIGNEE_NOT_BACKED, carrying the
// unbacked ids) so the UI can confirm; the operator's confirmation re-PUTs with
// `grant_backing: true`, which writes the companion scope grant in the same tx as
// the chain. Naming still grants nothing on its own — this is the operator's
// separate, deliberate, declinable scope grant (scope ⊥ accountability holds).
// ── PUT …/<scope>/<id>/responsibilities/:responsibilityId/assignments ───────
export const SetAssignmentChainRequestSchema = z
    .object({
    ...stampedBody,
    userIds: z.array(z.string().trim().min(1).max(16)).max(50),
    grant_backing: z.boolean().default(false),
})
    .strict();
